const syncFormShowOrHideState = () => {
	const forms = document.querySelectorAll('form');

	forms.forEach((form) => {
		for (const element of form.querySelectorAll('.js-show-on-value')) {
			const dependentElement = document.querySelector(element.dataset.element);
			const showIfValue = element.dataset.showif.toString();

			if (!showIfValue) {
				console.error({error: '[data-showif] Missing', element});
			}

			let showElement = true;

			if (showIfValue === ':checked') {
				showElement = dependentElement.checked;
			} else if (showIfValue === ':not(:checked)') {
				showElement = !dependentElement.checked;
			} else {
				showElement = showIfValue.includes(dependentElement.value);
			}

			element.hidden = !showElement;
			element.querySelectorAll('input, select, textarea')
				.forEach(el => el.disabled = !showElement);
		}
	});
};

export const initSyncFormShowOrHideState = () => {
	syncFormShowOrHideState();

	document.querySelectorAll('.js-on-change').forEach((element) => {
		element.addEventListener('change', () => {
			syncFormShowOrHideState();
		});
	});
};
